"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoomMcpServer = createLoomMcpServer;
const index_js_1 = require("@modelcontextprotocol/sdk/server/index.js");
const types_js_1 = require("@modelcontextprotocol/sdk/types.js");
const state_1 = require("./resources/state");
const status_1 = require("./resources/status");
const linkIndex_1 = require("./resources/linkIndex");
const diagnostics_1 = require("./resources/diagnostics");
const summary_1 = require("./resources/summary");
const refs_1 = require("./resources/refs");
const roadmap_1 = require("./resources/roadmap");
const docs_1 = require("./resources/docs");
const context_1 = require("./resources/context");
const plan_1 = require("./resources/plan");
const requiresLoad_1 = require("./resources/requiresLoad");
const createIdea = __importStar(require("./tools/createIdea"));
const createDesign = __importStar(require("./tools/createDesign"));
const createPlan = __importStar(require("./tools/createPlan"));
const createReq = __importStar(require("./tools/createReq"));
const amendReq = __importStar(require("./tools/amendReq"));
const finalizeReq = __importStar(require("./tools/finalizeReq"));
const createThread = __importStar(require("./tools/createThread"));
const createWeave = __importStar(require("./tools/createWeave"));
const setPriority = __importStar(require("./tools/setPriority"));
const setThreadDeps = __importStar(require("./tools/setThreadDeps"));
const updateDoc = __importStar(require("./tools/updateDoc"));
const patchDoc = __importStar(require("./tools/patchDoc"));
const appendToChat = __importStar(require("./tools/appendToChat"));
const readChatTail = __importStar(require("./tools/readChatTail"));
const createChat = __importStar(require("./tools/createChat"));
const startPlan = __importStar(require("./tools/startPlan"));
const completeStep = __importStar(require("./tools/completeStep"));
const updateStep = __importStar(require("./tools/updateStep"));
const addStep = __importStar(require("./tools/addStep"));
const removeStep = __importStar(require("./tools/removeStep"));
const reorderSteps = __importStar(require("./tools/reorderSteps"));
const closePlan = __importStar(require("./tools/closePlan"));
const recordRelease = __importStar(require("./tools/recordRelease"));
const promote_1 = require("./tools/promote");
const refineIdea_1 = require("./tools/refineIdea");
const refinePlan_1 = require("./tools/refinePlan");
const refineDesign_1 = require("./tools/refineDesign");
const finalizeDoc = __importStar(require("./tools/finalizeDoc"));
const archive = __importStar(require("./tools/archive"));
const deleteItem = __importStar(require("./tools/delete"));
const restore = __importStar(require("./tools/restore"));
const rename = __importStar(require("./tools/rename"));
const renameWeave = __importStar(require("./tools/renameWeave"));
const renameThread = __importStar(require("./tools/renameThread"));
const moveThread = __importStar(require("./tools/moveThread"));
const renameDocFile = __importStar(require("./tools/renameDocFile"));
const findDoc = __importStar(require("./tools/findDoc"));
const searchDocs = __importStar(require("./tools/searchDocs"));
const getBlockedSteps = __importStar(require("./tools/getBlockedSteps"));
const getStalePlans = __importStar(require("./tools/getStalePlans"));
const getStaleDocs = __importStar(require("./tools/getStaleDocs"));
const validate = __importStar(require("./tools/validate"));
const generate_1 = require("./tools/generate");
const verifyReq_1 = require("./tools/verifyReq");
const refreshCtx_1 = require("./tools/refreshCtx");
const doStep = __importStar(require("./tools/doStep"));
const appendDone = __importStar(require("./tools/appendDone"));
const listPlanSteps = __importStar(require("./tools/listPlanSteps"));
const createReference = __importStar(require("./tools/createReference"));
const setContextPrefs = __importStar(require("./tools/setContextPrefs"));
const getContextPrefs = __importStar(require("./tools/getContextPrefs"));
const catalog_1 = require("./catalog");
const continueThread = __importStar(require("./prompts/continueThread"));
const doNextStep = __importStar(require("./prompts/doNextStep"));
const refineDesign = __importStar(require("./prompts/refineDesign"));
const weaveIdea = __importStar(require("./prompts/weaveIdea"));
const weaveDesign = __importStar(require("./prompts/weaveDesign"));
const weavePlan = __importStar(require("./prompts/weavePlan"));
const validateState = __importStar(require("./prompts/validateState"));
function reg(group, mods) {
    return mods.map(m => ({ toolDef: m.toolDef, handle: m.handle, group }));
}
const PROMPTS = [
    continueThread, doNextStep, refineDesign, weaveIdea, weaveDesign, weavePlan, validateState,
];
const CONCRETE_RESOURCES = [
    { uri: 'loom://state', name: 'Loom State', description: 'Full project state (weaves, threads, plans)', mimeType: 'application/json' },
    { uri: 'loom://status', name: 'Loom Status', description: 'Raw .loom/_status.md content (Stage 1 only)', mimeType: 'text/plain' },
    { uri: 'loom://link-index', name: 'Link Index', description: 'Document graph: id→path (byId, documents), parent/child relationships, backlinks, slugs', mimeType: 'application/json' },
    { uri: 'loom://diagnostics', name: 'Diagnostics', description: 'Broken links, orphaned docs', mimeType: 'application/json' },
    { uri: 'loom://summary', name: 'Summary', description: 'Project health counts', mimeType: 'application/json' },
    { uri: 'loom://roadmap', name: 'Roadmap', description: 'Derived cross-weave roadmap: future (pending/blocked, dependency+priority order), present (active/implementing), history (shipped plans), and diagnostics (cycles, dangling deps, missing thread.md)', mimeType: 'application/json' },
    { uri: 'loom://catalog', name: 'Tool Catalog', description: 'Grouped index of all loom_* MCP tools (name + one-line purpose). Read this BEFORE searching for a tool, then ToolSearch select:<exact name>.', mimeType: 'text/markdown' },
    { uri: 'loom://refs', name: 'References', description: 'Reference docs under loom/refs/ as { id, title, file } — backs the requires_load picker', mimeType: 'application/json' },
];
const RESOURCE_TEMPLATES = [
    { uriTemplate: 'loom://docs/{id}', name: 'Document', description: 'Raw markdown of any Loom document by id', mimeType: 'text/plain' },
    { uriTemplate: 'loom://context/{docId}', name: 'Context Bundle', description: 'Unified context pipeline: global/weave/thread ctx + parent chain + requires_load for a target doc. Forms: loom://context/{docId} or loom://context/thread/{weaveId}/{threadId}. Append ?mode={chat|idea|design|plan|implementing|refine|promote|ctx}', mimeType: 'text/plain' },
    { uriTemplate: 'loom://plan/{id}', name: 'Plan', description: 'Plan document with parsed steps table as JSON', mimeType: 'application/json' },
    { uriTemplate: 'loom://requires-load/{id}', name: 'Requires Load', description: 'All docs listed in requires_load for a document (recursive, deduplicated)', mimeType: 'application/json' },
];
function createLoomMcpServer(root) {
    const server = new index_js_1.Server({ name: 'loom', version: '1.1.0' }, { capabilities: { resources: {}, tools: {}, prompts: {} } });
    const TOOLS = [
        ...reg('create', [createIdea, createDesign, createPlan, createReq, createReference, createChat, createWeave]),
        ...reg('doc', [updateDoc, patchDoc, finalizeDoc, archive, restore, deleteItem, rename, renameDocFile, (0, promote_1.createPromoteTool)(server)]),
        ...reg('refine', [(0, refineIdea_1.createRefineIdeaTool)(server), (0, refinePlan_1.createRefinePlanTool)(server), (0, refineDesign_1.createRefineDesignTool)(server)]),
        ...reg('generate', (0, generate_1.createGenerateTools)(server)),
        ...reg('plan', [startPlan, completeStep, updateStep, addStep, removeStep, reorderSteps, closePlan, recordRelease, doStep, appendDone, listPlanSteps]),
        ...reg('req', [amendReq, finalizeReq, (0, verifyReq_1.createVerifyReqTool)(server)]),
        ...reg('thread', [createThread, setPriority, setThreadDeps, renameThread, moveThread]),
        ...reg('weave', [renameWeave]),
        ...reg('chat', [appendToChat, readChatTail]),
        ...reg('context', [setContextPrefs, getContextPrefs, (0, refreshCtx_1.createRefreshCtxTool)()]),
        ...reg('query', [findDoc, searchDocs, getBlockedSteps, getStalePlans, getStaleDocs, validate]),
    ];
    // Build the discovery catalog once from the live registry (static for this server).
    (0, catalog_1.registerToolCatalog)((0, catalog_1.buildToolCatalog)(TOOLS));
    server.setRequestHandler(types_js_1.ListResourcesRequestSchema, async () => ({
        resources: CONCRETE_RESOURCES,
    }));
    server.setRequestHandler(types_js_1.ListResourceTemplatesRequestSchema, async () => ({
        resourceTemplates: RESOURCE_TEMPLATES,
    }));
    server.setRequestHandler(types_js_1.ReadResourceRequestSchema, async (request) => {
        const uri = request.params.uri;
        if (uri === 'loom://state' || uri.startsWith('loom://state?')) {
            return (0, state_1.handleStateResource)(root, uri);
        }
        if (uri === 'loom://status') {
            return (0, status_1.handleStatusResource)(root);
        }
        if (uri === 'loom://link-index') {
            return (0, linkIndex_1.handleLinkIndexResource)(root);
        }
        if (uri === 'loom://diagnostics') {
            return (0, diagnostics_1.handleDiagnosticsResource)(root);
        }
        if (uri === 'loom://summary') {
            return (0, summary_1.handleSummaryResource)(root);
        }
        if (uri === 'loom://refs') {
            return (0, refs_1.handleRefsResource)(root);
        }
        if (uri === 'loom://roadmap') {
            return (0, roadmap_1.handleRoadmapResource)(root, uri);
        }
        if (uri === 'loom://catalog') {
            return { contents: [{ uri, mimeType: 'text/markdown', text: (0, catalog_1.getToolCatalogBlock)() }] };
        }
        if (uri.startsWith('loom://docs/')) {
            return (0, docs_1.handleDocsResource)(root, uri);
        }
        if (uri.startsWith('loom://context/')) {
            return (0, context_1.handleContextResource)(root, uri);
        }
        if (uri.startsWith('loom://plan/')) {
            return (0, plan_1.handlePlanResource)(root, uri);
        }
        if (uri.startsWith('loom://requires-load/')) {
            return (0, requiresLoad_1.handleRequiresLoadResource)(root, uri);
        }
        throw new Error(`Unknown resource URI: ${uri}`);
    });
    server.setRequestHandler(types_js_1.ListToolsRequestSchema, async () => ({
        tools: TOOLS.map(t => t.toolDef),
    }));
    server.setRequestHandler(types_js_1.CallToolRequestSchema, async (request) => {
        const { name, arguments: args } = request.params;
        const tool = TOOLS.find(t => t.toolDef.name === name);
        if (!tool) {
            throw new Error(`Unknown tool: ${name}`);
        }
        return tool.handle(root, (args ?? {}));
    });
    server.setRequestHandler(types_js_1.ListPromptsRequestSchema, async () => ({
        prompts: PROMPTS.map(p => p.promptDef),
    }));
    server.setRequestHandler(types_js_1.GetPromptRequestSchema, async (request) => {
        const { name, arguments: args } = request.params;
        const prompt = PROMPTS.find(p => p.promptDef.name === name);
        if (!prompt) {
            throw new Error(`Unknown prompt: ${name}`);
        }
        return prompt.handle(root, (args ?? {}));
    });
    return server;
}
